import { render, staticRenderFns } from "./MailSegnalazioneCustomer.vue?vue&type=template&id=11fccc17&scoped=true"
import script from "./MailSegnalazioneCustomer.vue?vue&type=script&lang=js"
export * from "./MailSegnalazioneCustomer.vue?vue&type=script&lang=js"
import style0 from "./MailSegnalazioneCustomer.vue?vue&type=style&index=0&id=11fccc17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fccc17",
  null
  
)

export default component.exports